// frontend/src/redux/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import authReducer         from './auth'
import tripperUserReducer  from './tripperUser'
import questReducer        from './questUser'
import connectionReducer   from './connectionSlice'
import notificationReducer from './notificationSlice'
import adminReducer        from './adminSlice'
import partnerReducer      from './partnerSlice'
import bookingReducer      from './bookingSlice'
import messageReducer      from './messageSlice'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth']     // only persist auth
}

// combine all reducers
const rootReducer = combineReducers({
  auth:          authReducer,
  tripperUser:   tripperUserReducer,
  quests:        questReducer,
  connections:   connectionReducer,
  notifications: notificationReducer,
  admin:         adminReducer,
  partner:       partnerReducer,
  booking:       bookingReducer,
  messages:      messageReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false   // needed when using redux-persist
    })
})

export const persistor = persistStore(store)